import { createFileRoute } from '@tanstack/react-router';
import { DebtsCard } from '@/components/finance/debts';

// Debts (non-loan obligations, FEC Schedule D) are working data that feed report
// schedules, so the card mounts here as a first-class Finance tab instead of under
// Campaign Settings. Schedule D is federal-only, so the primary-nav Debts tab is
// suppressed for non-federal committees (see FinanceLayout); DebtsCard itself also
// renders null off-federal, so a direct visit stays blank-safe. The card is
// self-contained (its own query hooks); the route only frames it.
export const Route = createFileRoute('/admin/finance/debts/')({
  component: FinanceDebtsPage,
});

function FinanceDebtsPage() {
  return (
    <div className="p-6">
      <div className="max-w-3xl">
        <DebtsCard />
      </div>
    </div>
  );
}
